import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { BankCardInput as LocalBankCardInput } from '../../components/BankCardInput'

export const BankCardInput = connect(
  LocalBankCardInput,
  mapReadPretty(LocalBankCardInput, {
    disabled: true
  })
)
